import { Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import LearnPage from "./pages/LearnPage";
import PracticePage from "./pages/PracticePage";
import FlashCardPage from "./pages/FlashCardPage";
// import VideoLearningPage from "./pages/VideoLearningPage";
import AboutPage from './pages/AboutPage';
import TuneViolinPage from "./pages/TuneViolinPage";
import PitchTestsPage from "./pages/PitchTestsPage";

const AppRoutes = () => {
	return (
		<Routes>
			<Route exact path="/" element={<HomePage/>}/>
			<Route path="/flashcards/:id" element={<FlashCardPage/>}/>
			<Route path="/learn/:id" element={<LearnPage/>}/>
			<Route path="/practice/:id" element={<PracticePage />} />
			<Route exact path="/about" element={<AboutPage/>} />
			{/* <Route exact path="/video_learning" element={<VideoLearningPage/>} /> */}
			<Route exact path="/tune_violin" element={<TuneViolinPage/>} />
			<Route exact path="/pitch_tests" element={<PitchTestsPage/>} />
		</Routes>
	);
}
  
export default AppRoutes;